const signatureHash = (value) => {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0;
  }
  return Math.abs(hash).toString(36);
};

export const getClassroomHandoverIdempotencyKey = (classId, operation, version, payload) =>
  `classroom-handover:${classId}:${operation}:${version}:${signatureHash(JSON.stringify(payload))}`;
